module.exports = __webpack_public_path__ + "static/media/audi-bg.bb3c1920.png";